module.exports = __webpack_public_path__ + "files/96ec0fb404df197698e27886cadb906a.png";